import { AdvantageDescription, AdvantagesWrapper, AdvantageTitle, AdvantageWrapper, ClientDescription, ClientTitle, CloseButton, FrameTitleWrapper, IconWrapper, ImageContainer, ModalContent, ModalOverlay, StaticVideo, TitleWrapper, VideoButton, Wrapper } from "./styles";
import React from "react";
import { ADVANTAGES } from "./constants";
import { MdPlayArrow } from "react-icons/md";


const AdvantagesSection: React.FC = () => {
  const [showVideo, setShowVideo] = React.useState<boolean>(false);
  const videoId: string = "-TuGnHU_ZpA";

  const openVideo = (): void => setShowVideo(true);
  const closeVideo = (): void => setShowVideo(false);

  return (
    <Wrapper>
      <FrameTitleWrapper>
        <ImageContainer>
          <StaticVideo autoPlay muted loop>
            <source src="/video_anunciantee.mp4" type="video/mp4" />
            Seu navegador não suporta vídeos HTML5.
          </StaticVideo>
          <VideoButton onClick={openVideo}>
            Ver Vídeo
            <MdPlayArrow size={20} style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
          </VideoButton>
        </ImageContainer>

        {showVideo && (
          <ModalOverlay onClick={closeVideo}>
            <ModalContent onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              <CloseButton onClick={closeVideo}>×</CloseButton>
              <div style={{
                position: 'relative',
                width: '100%',
                height: 0,
                paddingTop: '177.77%',
                overflow: 'hidden'
              }}>
                <iframe
                  title="videoEmbed"
                  src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=0&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                />
              </div>
            </ModalContent>
          </ModalOverlay>
        )}

        <TitleWrapper>
          <ClientTitle>Fácil para o anunciante</ClientTitle>
          <ClientDescription>
            Tenha o seu imóvel alugado em tempo recorde!
          </ClientDescription>
        </TitleWrapper>
      </FrameTitleWrapper>

      <AdvantagesWrapper>
        {ADVANTAGES.map((advantage) => (
          <AdvantageWrapper key={advantage.title}>
            <IconWrapper>{advantage.icon}</IconWrapper>
            <AdvantageTitle>{advantage.title}</AdvantageTitle>
            <AdvantageDescription>
              {advantage.description}
            </AdvantageDescription>
          </AdvantageWrapper>
        ))}
      </AdvantagesWrapper>
    </Wrapper>
  );
};

export default AdvantagesSection;
